export default function Meta() {
  return (
    <>
      <title>Flight Maps</title>
      <meta
        name="description"
        content="An app for visualizing your flights."
      />
      <script
        async
        defer
        data-website-id="39ac75f0-91b8-46a6-89df-35ffd2f1a608"
        src="https://umami.niknia.dev/umami.js"
      ></script>
    </>
  );
}
